import { ConversationType } from '../core/hub-types';

/**
 * The colour of a conversation, by what kind it is, so the chat window says at a glance where you are writing: a
 * patient's chat (orange), a group (blue), a direct message in the practice (teal), a colleague outside the practice
 * (indigo), a referral chat with another practice (purple), a patient writing from the patient app (red), MedicAI
 * Support (slate), the practice's billing team on MedicAI Connect (green, 2026-10-05). The colours themselves live in chat-window.component.scss.
 */
export type ConversationTone = 'none' | 'patient' | 'group' | 'direct' | 'network' | 'referral' | 'patient-app' | 'support' | 'billing';

const TONES: Record<ConversationType, ConversationTone> = {
  patient: 'patient',
  channel: 'group',
  direct: 'direct',
  group_dm: 'direct',
  network: 'network',
  referral: 'referral',
  patient_direct: 'patient-app',
  support: 'support',
  billing: 'billing',
};

export function conversationTone(type: ConversationType | null | undefined): ConversationTone {
  return type ? TONES[type] : 'none';
}

export interface SubtitleMember {
  principalId: string;
  name: string;
  online?: boolean;
}

/**
 * The line under the conversation's name, as WhatsApp's: who is in it, everyone else by name and you last; in a
 * one-to-one, whether the other person is online. `members` is null until they have been fetched.
 */
export function headerSubtitle(type: ConversationType, members: SubtitleMember[] | null, me: string | null | undefined, isMember: boolean): string {
  if (!members) return 'Tap to see who is here';
  const others = members.filter((m) => m.principalId !== me);
  if (type === 'direct') return others.some((m) => m.online) ? 'Online' : 'Tap for details';
  const names = others.map((m) => m.name);
  if (isMember) names.push('You');
  return names.join(', ');
}
